import { render, staticRenderFns } from "./expandable_section.vue?vue&type=template&id=6b04a34e&scoped=true&"
import script from "./expandable_section.vue?vue&type=script&lang=js&"
export * from "./expandable_section.vue?vue&type=script&lang=js&"
import style0 from "./expandable_section.vue?vue&type=style&index=0&id=6b04a34e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04a34e",
  null
  
)

export default component.exports